export default "__VITE_ASSET__e0d9453c__"